module.exports = __webpack_public_path__ + "29a501dc1fd7de99713f3ead6e20a47e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/university_notre_dame_2023_chart.png
// module id = 1754
// module chunks = 0